import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home.vue'
import Login from '@/view/login.vue' 
import Index from '@/view/index.vue' 
import Video from '@/view/video.vue' 
import Card from '@/view/card.vue' 
import Agreement from '@/view/agreement.vue' 
import Privacy from '@/view/privacy.vue' 
import AboutUs from '@/view/aboutUs.vue' 
import MyInfo from '@/view/myInfo.vue' 
import Feedback from '@/view/feedback.vue' 



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: 'login',
      children: [
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
		{
		  path: '/index',
		  name: 'index',
		  component: Index,
		},
		{
		  path: '/video',
		  name: 'video',
		  component: Video,
		},
		{
		  path: '/card',
		  name: 'card',
		  component: Card,
		},
		{
		  path: '/agreement',
		  name: 'agreement',
		  component: Agreement,
		},
		{
		  path: '/privacy',
		  name: 'privacy',
		  component: Privacy,
		},
		{
		  path: '/aboutUs',
		  name: 'aboutUs',
		  component: AboutUs,
		},
		{
		  path: '/myInfo',
		  name: 'myInfo',
		  component: MyInfo,
		},
		{
		  path: '/feedback',
		  name: 'feedback',
		  component: Feedback,
		},
		
		//   path: '/submit/:type',
		//   name: 'submit',
		//   component: Submit,
	
      ]
    },
  ]
})